import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { IBooleanSelectOption } from 'KnmPackage/MainModule/interfaces/IBooleanSelectOption';

import { IDecisionActForm } from '../interfaces/IDecisionActForm';

/**
 * Определяет, живут ли нарушенные обязательные требования на уровне тела паспорта.
 *
 * При добавлении акта (isNeedToAddAct = true) нарушения переезжают внутрь акта,
 * поэтому блок в теле паспорта скрывается — и валидировать его тоже не нужно.
 *
 * Условие должно совпадать с условием рендера блока DecisionViolations в
 * DecisionContent, иначе валидатор проверяет поле, которого нет в интерфейсе
 */
export const getIsDecisionViolationsInBody = ({
  created,
  settings,
  isNeedToAddAct,
  act,
}: {
  created: string | undefined;
  settings: IAdminSetting[] | undefined;
  isNeedToAddAct: IBooleanSelectOption | undefined;
  act: IDecisionActForm | undefined;
}): boolean => {
  const isUse4151 = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_223_4_1_16_STARTS_FROM,
  );

  if (!isUse4151) {
    return true;
  }

  const isEnablePaperlessDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  return isEnablePaperlessDocument
    ? isNeedToAddAct?.value !== undefined && !isNeedToAddAct.value
    : !isNeedToAddAct?.value || !act;
};
